// extracted by mini-css-extract-plugin
export default {"inputField":"LoginPage_inputField__BKl9U","bottomMargin":"LoginPage_bottomMargin__qdeXi"};